import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadUserByUsername } from "../redux/sagas/dataSagas";
import {
  getDataState,
  setUsernameLoadingState,
} from "../redux/slices/dataSlice";

/**
 * Hook to load a user by username
 * This is useful when navigating directly to a profile page using React Router
 * @param username The username to load
 */
export const useLoadUserByUsername = (username: string) => {
  const dispatch = useDispatch();
  const dataState = useSelector(getDataState);

  useEffect(() => {
    if (username) {
      // Check if this username is already loading or loaded (from middleware)
      const usernameState = dataState.data.userByUsername[username];
      const userAlreadyLoaded = Object.values(dataState.data.users).some(
        (user) => user.data?.username === username
      );
      if (!usernameState && !userAlreadyLoaded) {
        dispatch(setUsernameLoadingState(username));
        loadUserByUsername(username, false);
      }
    }
  }, [username, dispatch, dataState]);
};
